<template>
  <div class="Main">
    <video-player
      ref="videoPlayer"
      class="player-video"
      :playsinline="false"
      :options="playOptions"
      @ready="onPlayerReady"
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)"
      @ended="onPlayerEnd($event)"
      @waiting="onPlayerWaiting($event)"
      @playing="onPlayerPlaying($event)"
      @loadeddata="onPlayerLoadeddata($event)"
      @timeupdate="onPlayerTimeupdate($event)"
      @statechanged="playerStateChanged($event)"
    />
  </div>
</template>
  
  <script>
export default {
  name: "MyVideoPlayer",
  props: {
    item: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      thumbnail: null,
      isPlaying: false,
      api: process.env.VUE_APP_BASE_API,
    };
  },
  computed: {
    playOptions() {
      return {
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        autoplay: false,
        muted: false,
        loop: false,
        preload: "auto",
        language: "zh-CN",
        aspectRatio: "16:9",
        fluid: true,
        sources: [
          {
            src: this.item,
            type: "video/mp4",
          },
        ],
        poster:this.api + this.image,
        notSupportedMessage: "此视频暂不支持播放，请稍后再试！",
        controlBar: {
          timeDivider: true,
          duration: true,
          remainingTime: false,
          fullscreenToggle: true,
          playbackRateMenuButton: false,
        },
      };
    },
  },
  methods: {
    // 准备好了
    onPlayerReady() {},
    // 视频播放
    onPlayerPlay(player) {
      this.isPlaying = true;
    },
    // 视频暂停的
    onPlayerPause(player) {
      this.isPlaying = false;
    },
    // 视频播放完
    onPlayerEnd(player) {
      this.isPlaying = false;
    },
    // DOM元素上的readyState更改导致播放停止
    onPlayerWaiting(player) {},
    // 视频已开始播放
    onPlayerPlaying(player) {},
    // 当播放器在当前播放位置下载数据时触发
    onPlayerLoadeddata(event) {

    },
    // 当前播放位置发生变化时触发
    onPlayerTimeupdate(player) {
    },
    //播放状态改变
    playerStateChanged(playerCurrentState) {},
    // 手动暂停视频的播放
    pause() {
      // 视频播放器的方法调用，要使用this.$refs.videoPlayer.player这个对象去调用
      this.$refs.videoPlayer.player.pause();
    },
  },
};
</script>
  
<style scoped lang="less">
.Main {
  width: 100%;
  max-width: 750px;
}
.player-video {
  width: 100%;
  height: auto;
}
::v-deep .video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
  width: 100%;
}
::v-deep .video-js .vjs-big-play-button {
  font-size: 3em;
  line-height: 1.5em;
  height: 1.5em;
  width: 3em;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0;
  cursor: pointer;
  opacity: 1;
  border: 0.06666em solid #fff;
  background-color: #2b333f;
  background-color: rgba(43, 51, 63, 0.7);
  border-radius: 0.3em;
  transition: all 0.4s;
}
::v-deep .video-js.vjs-playing .vjs-big-play-button {
  display: none;
}
</style>